import { PluginType } from '@deephaven/plugin';
import { dhTable } from '@deephaven/icons';
import { GridWidgetPlugin } from "./GridWidgetPlugin.js";
import { GridPanelPlugin } from "./GridPanelPlugin.js";
var GridPluginConfig = {
  name: 'IrisGridPanel',
  title: 'Table',
  type: PluginType.WIDGET_PLUGIN,
  component: GridWidgetPlugin,
  panelComponent: GridPanelPlugin,
  supportedTypes: ['Table', 'TreeTable', 'HierarchicalTable', 'PartitionedTable'],
  icon: dhTable
};
export default GridPluginConfig;
//# sourceMappingURL=GridPluginConfig.js.map